import { render } from "./InstanceCreationScreen.vue?vue&type=template&id=1dbebfec&scoped=true"
import script from "./InstanceCreationScreen.vue?vue&type=script&lang=js"
export * from "./InstanceCreationScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=1dbebfec&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbebfec"]])

export default __exports__